module.exports = __webpack_public_path__ + "static/img/h5_qr.a5e6ae9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5_qr.jpg
// module id = k4nT
// module chunks = 1